// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1HtFl","notes":"Notes_notes__1tra_"};